<template>
  <div class="regin">
    <div class="title">房产交易成功</div>
    <div class="line">
      <span class="lable">地址</span>
      <input type="text" name="" v-model="address" id="address" ref="address" placeholder="地址" />
    </div>
    <div class="line">
      <span class="lable">实际成交</span>
      <input type="text" name="" v-model="price" id="price" ref="price" @blur="dealAmount" placeholder="实际成交(万元)" />
      <!--      <span>万元</span>-->
      <!-- 实际成交金额可以修改,修改后生成对应的佣金 -->
    </div>
    <div class="line">
      <span class="lable">佣金</span>
      <input v-model="brokerage" type="text" name="" placeholder="" />
      <!--      <span>元</span>-->
      <!-- 佣金可以修改 买卖 0.1%  租 10%  预留积分抵用方式-->
    </div>

    <div v-if="deal_end == '0'" class="bottomBtn" @click="to_pay()">邀请房主确认完成交易</div>
    <div v-if="deal_end == '2'" class="bottomBtn">请等待房主确认</div>
    <div v-if="deal_end == '3'" class="bottomBtn" @click="save()">确认已成交并支付{{brokerage}}元佣金</div>


    <div v-if="deal_end == '1'" class="bottomBtn" @click="set_status(0)">我不同意完成交易</div>
    <div v-if="deal_end == '1'" class="bottomBtn" @click="set_status(1)">我同意完成交易</div>

  </div>
</template>

<script>
  import {
    RadioGroup,
    Radio,
    DatetimePicker,
    Popup,
    Cascader,
    Toast
  } from "vant";
  import {
    RequestApi
  } from "@/apis/demo.js";
  import Cookies from 'js-cookie';
  import {
    getQueryVariable
  } from "@/utils/request";
  import axios from "axios";
  import qs from "qs";

  // import {
  //   DropdownMenu,
  //   DropdownItem
  // } from 'vant';

  // Vue.use(DropdownMenu);
  // Vue.use(DropdownItem);

  // import { Picker } from 'vant';

  // Vue.use(Picker);

  export default {
    name: "regin",
    props: {},
    data() {
      return {
        houseId: "", //房屋的id, 暂时写死, 应由Stab传递过来
        userCode: "",
        housename: "", //小区名称
        title: "",
        imgurl: "",
        price: 0, //成交价格
        priceRegex: /^(([1-9]\d*)(\.\d{1,4})?)$|(0\.\d{1,4})$/,
        room: "",
        hall: "",
        toilet: "",
        balcony: "",
        houseearm: "",
        adddate: "",
        houseyear: "2020", //房屋年龄
        floor1: '3', //几楼
        floor2: '5', //共几层
        editdate: '', //修改日期
        address: "",
        content: "", //详情
        brokerage: 0, //佣金
        deal_end: '-100', //1 主人确认  2 等待主人确认 3主人确认了 4 拒绝了
      };
    },
    components: {

    },
    mounted() {
      //判断一下，cookie如果丢失了，那么就重新登录
      if (Cookies.get("kh") == "" || Cookies.get("kh") == null) {
        //如果获取用户信息失败那就直接跳到登录
        this.$router.push("login");
        return;
      }
      this.userCode = Cookies.get("kh");
      console.log(this.$route.params);
      //this.houseId = this.$route.params.houseid;
      //读出配置信息
      this.getHouseDetails();

    },
    methods: {
      //给页面注入wxjs
      async getWxConfig() {
        //获取会员部分信息
        let openurl = location.href.split("#")[0];
        let that = this;
        let uri = this.$global.domain + "/tools/post.ashx";
        var param = {
          act: "getwxconfig",
          openurl: openurl,
          sitenum: "18777777777",
          token: Cookies.get("token"),
        };
        var result = await RequestApi.post(uri, param);
        console.log(result);
        if (result.status == "1") {
          wx.config({
            debug: false,
            appId: result.appId,
            timestamp: result.timestamp,
            nonceStr: result.nonceStr,
            signature: result.signature,
            jsApiList: [
              'onMenuShareTimeline',
              'onMenuShareAppMessage',
              'onMenuShareQQ',
              'onMenuShareQZone',
              'updateTimelineShareData',
              'updateAppMessageShareData',
              'showOptionMenu'
            ]
          });
          wx.ready(function() {
            // //console.log("js注册成功");
            //Toast("微信js注册成功");
            var shareData = {
              title: '快乐建家首页', //标题
              desc: '快乐建家,集交友,房屋租售,招聘等一起的平台，您也快来参与吧！', //介绍文字
              link: 'http://joyhome.winwinchina.com/#/select?r_id=' + Cookies.get("kh"), //打开地址,要将分享人的编号加进来
              imgUrl: 'http://peng-mall.5izg.cn/img/logo.364a3941.png' //分享的图片地址
            };
            wx.updateTimelineShareData(shareData); //分享到朋友圈
            wx.updateAppMessageShareData(shareData); //分享给好友
          });
        } else {
          Toast(result.msg);
        }
      },
      async to_pay() {
        //发起询问,问问房东,是不是可以确认交易了

        //给对方发一个消息,对方收到后可以确认,确认后这边按钮变为退费按钮
        let url = location.href;
        let id = decodeURI(getQueryVariable(url, "id"));
        var that = this;
        var uri = "";
        uri = this.$global.domain + "/tools/post_job.ashx";
        var param = {
          act: "confirm_friend",
          user_other: this.owner, //房屋所有者编号
          user: Cookies.get("kh"), //发起人
          price: this.price, //本次实际的成交金额
          brokerage: this.brokerage, //佣金
          type: 'house', //类型 有friend house jobs
          id: id, //本次查询的房屋编号
          sitenum: '18777777777',
          token: Cookies.get("token"),
          code: Cookies.get("code"),
        };
        var result = await RequestApi.post(uri, param);
        //console.log(result);
        if (result.status == "1") {
          Toast(result.rsg);
          //延时跳转 让顾客看清提示
          setTimeout(() => {
            this.getHouseDetails(); //刷新一下页面
            //延迟时间：3秒
          }, 1000)

        } else {
          Toast(result.rsg);
        }
      },
      async set_status(state) {
        let url = location.href;
        let id = decodeURI(getQueryVariable(url, "id"));
        //房主确认是否同意结束
        var that = this;
        var uri = "";
        uri = this.$global.domain + "/tools/post_job.ashx";
        var param = {
          act: "set_status",
          user: Cookies.get("kh"), //确认人
          state: state,
          id: id, //房屋id
          type: 'house',
          // message: this.$refs.message.value, //赠言
          // receiveGiftUserCode: this.userCode, //查询指定会员的时候使用，必须是权限允许的会员
          sitenum: '18777777777',
          token: Cookies.get("token"),
          code: Cookies.get("code"),
        };
        var result = await RequestApi.post(uri, param);
        //console.log(result);
        if (result.status == "1") {
          Toast(result.rsg);
          //延时跳转 让顾客看清提示
          setTimeout(() => {
            //需要延迟的代码 :1秒后延迟跳转到首页，可以加提示什么的
               this.getHouseDetails();            
            //延迟时间：1秒
          }, 1000)
          //延时跳转 让顾客看清提示
          // setTimeout(() => {
          //   //需要延迟的代码 :1秒后延迟后退2步，第一步是选择礼品的，第二步才是用户发起界面
          //   if (this.deviceType == "pc") {
          //     //如果是pc，那么就是电脑用，千万不要退两步，退多了聊天页面都没了
          //     this.$router.back(); //后退+刷新；
          //   } else {
          //     this.$router.go(-2); //后退+刷新；
          //   }
          //   //延迟时间：3秒
          // }, 1000)

        } else {
          Toast(result.rsg);
        }
      },
      dealAmount() {
        console.log(this.price);
        if (!this.price || !this.priceRegex.test(this.price) || this.price <= 0) {
          Toast('输入错误');
        }
        this.calculateBrokerage();
      },
      onFinish({
        selectedOptions
      }) {
        this.nationActive = false;
        this.nationText = selectedOptions.map((option) => option.text).join("/");
      },
      async save() {
        //发起支付,支付后标记交易完成
        if (!this.price || !this.priceRegex.test(this.price) || this.price <= 0) {
          Toast('输入错误');
          return;
        }
        var that = this;
        console.log(this.houseId);
        const param = {
          id: this.houseId, //房屋id
          act: 'recharge',
          type: 'house_deal_done',
          user: Cookies.get('kh'),
          sitenum: this.$global.sitenum,
          paylx: 'weixinpay',
          je: this.brokerage,
          sblx: 'h5',
          openid: Cookies.get('openid'),
          remark: '房屋租售佣金'
        };
        const url = this.$global.domain + "/horse/tools/post.ashx";
        console.log(param);
        console.log(url);
        axios.post(url, qs.stringify(param))
          .then(res => {
            console.log(res.data);
            if (res.data.status == 1) {
              const orderId = res.data.djh; //订单id
              //跳转网址
              window.location.href = this.$global.domain + "/horse/WXpay/jsapipay.aspx?type=house&houseid=" + that
                .houseId + "&openid=" + Cookies.get(
                  'openid') + "&djh=" + orderId + "&sitenum=" + that.$global.sitenum
            }
          });
      },
      async getHouseDetails() {
        //房屋信息
        let url = location.href;
        let id = decodeURI(getQueryVariable(url, "id"));
        var that = this;
        var uri = "";
        uri = this.$global.domain + "/tools/postmysql.ashx";
        var param = {
          act: "getHouseDetails",
          id: id, //本次查询的房屋编号
          user: Cookies.get("kh"),
          sitenum: '18777777777',
          token: Cookies.get("token"),
        };
        var result = await RequestApi.post(uri, param);
        console.log(result);
        if (result.status == "1") {
          let data = result.data;
          that.id = data[0][0];
          that.img_url = data[0][2];
          that.title = data[0][1];
          that.add_date = data[0][9];
          that.price = data[0][3];
          that.houseearm = data[0][8];
          that.room = data[0][4];
          that.hall = data[0][5];
          that.toilet = data[0][6];
          that.balcony = data[0][7];
          that.content = data[0][10]; //详情
          that.housename = data[0][11];
          that.address = data[0][12];
          that.owner = data[0][15]; //房子主人编号
          that.deal_end = data[0][23];
          // kh: data[i].kh,
          //计算佣金
          this.calculateBrokerage();

          //如果已经在确认交易流程,这里读出来填写的成交金额和佣金
          if (data[0][25] != '') {
            that.price = data[0][25];
            that.brokerage = data[0][26];
          }
        } else {
          this.$router.push("login");
        }
      },
      calculateBrokerage() {
        if (!this.price || !this.priceRegex.test(this.price) || this.price <= 0) {
          this.brokerage = 0;
        } else {
          const total = this.price * 10000;
          const brokerage = total / 1000;
          this.brokerage = brokerage;
        }

      }
    },
    computed: {},
    watch: {},
  };
</script>

<style scoped lang="less">
  .regin {
    .title {
      height: 68px;
      line-height: 68px;
      width: 348px;
      position: relative;
      margin: 0 auto;
      font-size: 18px;
      font-weight: bold;
      text-align: left;
      color: #3d3d3d;
    }

    .line {
      height: 54px;
      line-height: 54px;
      width: 348px;
      position: relative;
      margin: 0 auto;
      margin-bottom: 18px;
      font-size: 14px;
      text-align: left;
      color: #6e6e6e;

      // border: 1px red dashed;
      input {
        height: 50px;
        border: 1px #f2f2f2 solid;
        width: 344px;
        text-indent: 12px;
        color: #464646;
        text-indent: 70px;
      }

      .superIndent {
        text-indent: 120px;
      }

      .lable {
        text-indent: 12px;
        display: inline-block;
        // width: 76px;
        position: absolute;
      }

      .sexGroup {
        position: relative;
        // border: 1px red solid;
        width: 210px;
        margin-top: 17px;
        margin-left: 70px;
        display: inline-block;

      }

      .suojin {
        margin-left: 16px;
        left: 56px;
        position: relative;
      }

      .greenColor {
        position: relative;
        // border: 1px red solid;
        width: 280px;
        margin-top: 17px;
        margin-left: 30px;
        display: inline-block;

        i {
          color: #62c3ab;
          font-style: initial;
        }
      }
    }
  }

  .bottomBtn {
    position: relative;
    margin: 20px auto 20px auto;
    width: 354px;
    height: 54px;
    line-height: 54px;
    border-radius: 40px;
    background-color: #ea2e3a;
    color: white;
    font-size: 18px;
    font-weight: bold;
    text-align: center;
  }
</style>
